import axios from "axios";
import router from "@/router";
const errorsHandler = require("@/services/errors")

const module_sa = 'user/super-admin'

const state = {
    logged: false,
    user: {},
    role_name: ''
}

const getters = {
    getLogged: state => {
        return state.logged
    },
    getUser: state => {
        return state.user
    },
    getRoleName: state => {
        return state.role_name
    }
}

const actions = {
    login: async (context, payload) => {

        var url = 'api/v1/user/login-admin'
        return axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload)
            .then(response => {

                if (response.status == 201) {
                    if (response.data.active) {

                        context.commit('setUser', response.data)
                        context.commit('setLogged', true)

                        localStorage.setItem('expired_at', response.data.expired_at.toString())
                        localStorage.setItem('user', JSON.stringify(response.data))

                        const allCenters = [
                            response.data.center_id,
                            ...(response.data.additional_centers || [])
                        ];

                        const uniqueCenters = [...new Set(allCenters)];

                        localStorage.setItem('available_centers', JSON.stringify(uniqueCenters));

                        return {success: true}

                    } else {

                        return {success: false, message:'user_not_active'}

                    }

                }else {

                    return {success: false, message: response.data}

                }

            }).catch((error)=>{

                return {success: false, message: error.response.data}

            })
    },
    resetPassword: async (context, payload) => {

        let url = 'api/v1/user/recovery-password'
        return axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload)
            .then(response => {

                if (response.data && response.data.result) {

                    return {success: true}

                }else {

                    return {success: false, message: response.data}

                }

            }).catch((error)=>{

                return {success: false, message: error.response.data}

            })
    },
    checkToken: async (context, payload) => {

        let url = 'api/v1/user/check-token-password'
        return axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload)
            .then(response => {

                if (response.data && response.data._id) {

                    return {success: true, _id: response.data._id}

                }else {

                    return {success: false, message: response.data}

                }

            }).catch((error)=>{

                return {success: false, message: error.response.data}

            })
    },
    sendResetPassword: async (context, payload) => {

        let url = 'api/v1/user/reset-password'
        return axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload)
            .then(response => {

                if (response.data && response.data.success) {

                    return {success: true}

                }else {

                    return {success: false, message: response.data}

                }

            }).catch((error)=>{

                return {success: false, message: error.response.data}

            })
    },
    refreshToken: async (context, payload) => {

        var url = 'api/v1/user/refresh-token-admin'
        return axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload)
            .then(response => {

                if (response.status == 201) {
                    if (response.data.active) {

                        context.commit('setUser', response.data)
                        context.commit('setLogged', true)

                        localStorage.setItem('expired_at', response.data.expired_at.toString())
                        localStorage.setItem('user', JSON.stringify(response.data))

                        const allCenters = [
                            response.data.center_id,
                            ...(response.data.additional_centers || [])
                        ];

                        const uniqueCenters = [...new Set(allCenters)];

                        localStorage.setItem('available_centers', JSON.stringify(uniqueCenters));

                        return {success: true}

                    } else {

                        return {success: false, message:'user_not_active'}

                    }

                }else {

                    return {success: false, message: response.data}

                }

            }).catch((error)=>{

                return {success: false, message: error.response.data}

            })
    },
    logout: async (context) => {
        // detach push prima di perdere il Bearer; mai bloccare il logout
        try {
            await context.dispatch('pushNotifications/unregisterDevice', null, { root: true })
        } catch (error) {
            // noop
        }

        localStorage.setItem('expired_at', '')
        localStorage.setItem('user', '')
        localStorage.setItem('available_centers', '')

        context.commit('setLogged', false)
        context.commit('setUser', {})
        router.push('/login')
    },
    updateProfile: async (context, payload) => {

        var url = 'api/v1/user/update-admin-profile'

        var config = {
            'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
            "Content-Type": "application/json"
        }

        return axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, payload, config)
            .then(response => {

                if (response.status == 201) {

                    return response.data

                }else {

                    return {success: false, message: response.data}

                }

            }).catch((error)=>{

                return {success: false, message: error.response.data}

            })
    },

    superAdminIndex : async (context,payload) => {

        let url = `api/v1/${module_sa}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data.result

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    superAdminStore : async (context,payload) => {

        let url = `api/v1/${module_sa}/store/`;

        var formData = payload

        if(payload.file){

            formData = new FormData();
            for (const [key, value] of Object.entries(payload)) {
                formData.append(key, value)
            }

        }

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "multipart/form-data",
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    superAdminEdit : async (context,payload) => {

        let url = `api/v1/${module_sa}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    superAdminUpdate : async (context,payload) => {

        let url = `api/v1/${module_sa}/update/${payload.id}`;

        var formData = payload.item

        if(payload.item.file){

            formData = new FormData();
            for (const [key, value] of Object.entries(payload.item)) {
                formData.append(key, value)
            }

        }

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    superAdminDelete : async (context,payload) => {

        let url = `api/v1/${module_sa}/delete/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,{},{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    superAdminMassDelete : async (context,payload) => {

        let url = `api/v1/${module_sa}/mass-delete`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    }
}

const mutations = {
    setLogged: (state, value) => {
        state.logged = value
    },
    setUser: (state, value) => {
        state.user = JSON.parse(JSON.stringify(value))
    },
    setRoleName: (state, value) => {
        state.role_name = value
    },
    switchCenterId: (state, centerId) => {
        if (state.user && state.user._id) {
            state.user.center_id = centerId;

            const stored = localStorage.getItem('user');
            if (stored) {
                const parsed = JSON.parse(stored);
                parsed.center_id = centerId;
                localStorage.setItem('user', JSON.stringify(parsed));
            }
        }
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}

